module.exports = __webpack_public_path__ + "img/NN.3dd73452.png";